import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosPrivate } from "../../../config/axios";
import { ITripPayload, LIST_TRIPS_SLICE, TRIPS_URL } from "./trips.constant";
import { ErrorPopup } from "../../../utilities/swal";
import { IErrorResponse } from "../../../utilities/error.config";
import { IAxiosErrorResponse } from "../../../interface/axiosError";

export const onAddTrip = createAsyncThunk(
  `${LIST_TRIPS_SLICE}/add-list`,
  async (data: any, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.post(`${TRIPS_URL}`, data);

      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const onUpdateTrip = createAsyncThunk(
  `${LIST_TRIPS_SLICE}/edit-list`,
  async (data: { id: string; payload: ITripPayload }, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.put(
        `${TRIPS_URL}/${data?.id}`,
        data?.payload
      );
      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const onUpdateStatusTrip = createAsyncThunk(
  `${LIST_TRIPS_SLICE}/edit-status-list`,
  async (data: { id: string; status: string }, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.put(
        `${TRIPS_URL}/status/${data?.id}?status=${data?.status}`
      );
      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const onGetListTrip = createAsyncThunk(
  `${LIST_TRIPS_SLICE}/get-list`,
  async (
    payload: { dateFrom: string; status: string | null },
    thunkAPI: any
  ) => {
    try {
      const res = await axiosPrivate.get(
        `${TRIPS_URL}?dateFrom=${payload?.dateFrom}&status=${payload?.status}`
      );

      return {
        data: res?.data,
        dateFrom: payload?.dateFrom,
        status: payload?.status,
      };
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
